'use client'

import { User } from 'react-feather'

type PractitionerCardProps = {
  label: string
  name: string
  initials: string | null
  speciality: string
}

export function PractitionerCard({ label, name, initials, speciality }: PractitionerCardProps) {
  return (
    <div className="rounded-xl border border-primary/10 bg-primary/5 p-4">
      <h2 className="mb-3 text-sm font-medium text-gray-500">{label}</h2>
      <div className="flex items-center gap-3">
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary/10 text-sm font-semibold uppercase text-primary">
          {initials || <User size={22} aria-hidden="true" />}
        </span>
        <div className="min-w-0">
          <p className="truncate font-semibold text-gray-900">{name}</p>
          <p className="truncate text-sm capitalize text-gray-500">{speciality}</p>
        </div>
      </div>
    </div>
  )
}
